import { type FC } from 'react';
import cx from 'classnames';

import styles from './styles.module.css';

interface Props {
  className?: string;
}

export const BadgeTrending: FC<Props> = ({ className }) => (
  <span className={cx(styles.root, className)}>🔥 TRENDING</span>
);
